<template>
  <div class="text-center hero">
    <img class="mb-3 app-logo" src="../assets/final-logo.gif" alt="Vue.js logo" width="120" />
    <h1 class="mb-4">PharmFax Dashoard</h1>
    <p class="lead">
      Please Login to access your PharmFax Dashboard
      <!-- <a
        href="https://vuejs.org"
      >Vue.js</a> -->
    </p>
  </div>
</template>

<script>
export default {
  name: "Hero"
};
</script>
